import Header from "./header/Header";
import Content from "./content/Content";

const ScholarshipInfomation = () => {
  return (
    <div className="scholarship-info-section" id="scholarship">
      <Header />
      <Content />
    </div>
  );
};

export default ScholarshipInfomation;
